import { Box } from '@wix/design-system';
import {
  DEFAULT_PURCHASE_CYCLE,
  getStudioStyling,
  ProductHat,
  useAnonymous,
  useIsSeasonalSale,
  useProductHat,
} from '@wix/package-picker-shared-studio';
import {
  FeaturesGrid as PlatformFeaturesGrid,
  Price,
} from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import { SelectButton } from '../SelectButton';

interface FeaturesGridProductHeaderProps {
  productId: string;
}

export const FeaturesGridProductHeader = ({
  productId,
}: FeaturesGridProductHeaderProps) => {
  const { isAnonymous } = useAnonymous();
  const { data: product, isLoading } =
    StudioPackagePickerModule.SDK.studioOfferingApiClient.hooks.useFetchProduct(
      {
        productId,
      },
    );

  const { isRecommended, isEnterprise, name } = product ?? {};

  const { colors } = getStudioStyling();
  const { hasHat } = useProductHat({ productId });
  const isSeasonalSale = useIsSeasonalSale();

  if (isLoading) {
    return null;
  }

  const showTopBorder = isSeasonalSale ? true : !hasHat;

  return (
    <PlatformFeaturesGrid.Header.Cell
      borderTop={showTopBorder ? `3px solid ${colors.borderTop}` : undefined}
      gap="SP1"
    >
      <Box
        height="30px"
        marginTop={isSeasonalSale ? '3px' : '-28px'}
        marginLeft={isSeasonalSale ? '3px' : undefined}
        marginRight={isSeasonalSale ? '3px' : undefined}
      >
        {hasHat && <ProductHat productId={productId} />}
      </Box>
      <Box align="center" marginTop="SP2">
        <PlatformFeaturesGrid.Header.Title title={name ?? ''} size="small" />
      </Box>
      <Box visibility={isEnterprise ? 'hidden' : 'visible'}>
        <Price
          productId={productId}
          cycle={DEFAULT_PURCHASE_CYCLE}
          display={{ hideZeroDecimals: false, inline: false, size: 'tiny' }}
        />
      </Box>
      {!isAnonymous && (
        <Box align="center" width="100%" marginBottom="SP3" marginTop="SP1">
          <Box width="90%" align="center">
            <SelectButton
              filled={isRecommended}
              productId={productId}
              source="table"
            />
          </Box>
        </Box>
      )}
    </PlatformFeaturesGrid.Header.Cell>
  );
};
